export default {
    ca: {
        slideOne: {
            title: 'Instamaps és l\'eina gratuïta per crear els teus mapes',
        },
        slideTwo: {
            title: 'Fes un mapa amb les teves dades fàcilment',
        },
        slideThree: {
            title: 'Visualitza i analitza la teva informació sobre el mapa',
        },
        slideFour: {
            title: 'Insereix els teus mapes al teu web',
        },
    },
    es: {
        slideOne: {
            title: 'Instamaps es la herramienta gratuita para crear tus mapas',
        },
        slideTwo: {
            title: 'Haz un mapa fácilmente con tus datos',
        },
        slideThree: {
            title: 'Visualiza y analiza tu información sobre el mapa',
        },
        slideFour: {
            title: 'Inserta tus mapas en tu web',
        },
    },
    en: {
        slideOne: {
            title: 'Instamaps is the free tool to create your maps',
        },
        slideTwo: {
            title: 'Make a map with your data easily',
        },
        slideThree: {
            title: 'View and analyze your information on the map',
        },
        slideFour: {
            title: 'Insert your maps on your website',
        },
    },
};



// WEBPACK FOOTER //
// ./src/home/components/banner-slider/banner-slider-translations.js